/**
 * Created by Jan on 12.05.2017.
 */

/**
 * Created by Jan on 22.04.2017.
 */

(function (Lfl, $, undefined) {

    /*
     |===============================================================================================================
     | Namespace definition
     |===============================================================================================================
     */

    /**
     * A namespace containing members which help with identifying objects in the DOM.
     *
     * @memberOf Lfl
     */
    Lfl.DomIdentifying = Lfl.DomIdentifying || {};

    (function (DomIdentifying, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.DomIdentifying, 'DomIdentifying')) {
            return;
        }

        /*
         |-------------------------------------------------------------------------------------------------------------------
         | Public constants
         |-------------------------------------------------------------------------------------------------------------------
         */

        var constants =
            /**
             * The constants provided by this namespace.
             *
             * @memberOf Lfl.DomIdentifying
             */
            DomIdentifying.constants = {

            };

        // Lock down the constants and then the access to them.
        Object.freeze(DomIdentifying.constants);
        Object.defineProperty(DomIdentifying, "constants", {configurable: false, writable: false});


        /*
         |-----------------------------------------------------------------------------------------------------------
         | Public methods
         |-----------------------------------------------------------------------------------------------------------
         */

        /**
         *
         * @memberOf Lfl.DomIdentifying
         */

        /*
         |-----------------------------------------------------------------------------------------------------------
         | Private methods
         |-----------------------------------------------------------------------------------------------------------
         */
    }(Lfl.DomIdentifying, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));